import React, { useCallback, useEffect, useState } from "react";
import style from "./index.module.css";
import { alertV2, user, workOrder } from "../../../api/index.js";
import { parserAPI } from "../../../utils/parser.jsx";
import { toast } from "react-toastify";
import { formatDateTime, renderImage } from "../../../utils/helper.jsx";
import { useAuth } from "../../../contexts/AuthContext.jsx";
import { MentionsInput, Mention } from "react-mentions";
import classNames from "./mention.module.css";
import Attachment from "./attachment/index.jsx";
import AttachmentDownload from "./attachment/download.jsx";
const getNick = (name) => {
  if (!name) return "";
  const splitName = name.split(" ");
  let nick = "";
  splitName.forEach((s) => {
    nick += s.charAt(0);
  });

  return nick;
};
export const WorkOrderLog = ({ work_order_id, updateLastLog }) => {
  const { config } = useAuth();
  const [attachment, setAttachment] = useState("");
  const [attachmentName, setAttachmentName] = useState("");
  const [attachmentComment, setAttachmentComment] = useState("");
  const [attachmentCommentName, setAttachmentCommentName] = useState("");
  const [logs, setLogs] = useState([]);
  const [users, setUsers] = useState([]);
  const { email, username } = useAuth();
  async function getLogs() {
    try {
      const res = await workOrder.getLogs(work_order_id);
      const data = await parserAPI(res);

      setLogs(data);
    } catch (e) {
      toast.error(e.message);
    }
  }
  async function getUsers() {
    try {
      const res = await user.list();
      const data = await parserAPI(res);
      let user_list = [];
      data.map((u) => {
        user_list.push({
          id: u.email,
          display: u.firstname + " " + u.lastname,
        });
      });
      setUsers(user_list);
    } catch (e) {
      toast.error(e.message);
    }
  }
  useEffect(() => {
    getUsers();
  }, []);
  useEffect(() => {
    if (work_order_id) getLogs();
  }, [work_order_id]);
  const [showAddComment, setShowAddComment] = useState(null);
  const [commentText, setCommentText] = useState("");
  const [logText, setLogText] = useState("");
  const [mentionElement, setMentionElement] = useState(null);

  const [selectedUser, setSelectedUser] = useState([]);

  const handleClickAddComment = (index) => {
    if (index === showAddComment) {
      setShowAddComment(null);
    } else {
      setShowAddComment(index);
    }
    setAttachmentComment(null);
    setAttachmentCommentName(null);
  };

  const handleOpenMention = (event) => {
    setMentionElement(event.currentTarget);
  };

  const handleAttachment = async (e) => {
    if (!e.target.files || e.target.files.length === 0) {
      setAttachment(undefined);
      return;
    }
    setAttachmentName(e.target.files[0].name);
    setAttachment(e.target.files[0]);
  };
  const handleAttachmentComment = async (e) => {
    if (!e.target.files || e.target.files.length === 0) {
      setAttachmentComment(undefined);
      return;
    }
    setAttachmentCommentName(e.target.files[0].name);
    setAttachmentComment(e.target.files[0]);
  };

  const handleSubmitComment = async (id) => {
    if (commentText) {
      const payload = {
        email: email,
        feedback: commentText,
        alert_logs_id: id,
      };
      const res = await workOrder.addLogFeedbackAttachment(
        id,
        payload,
        attachmentComment
      );
      setCommentText("");
      setAttachmentComment(null);
      getLogs();
    }
  };

  const handleDelete = async (row) => {
    const res = await workOrder.deleteFeedback(row.work_order_log_id, row.id);
    getLogs();
  };
  const handleSubmitLogAttachment = async () => {
    if (logText) {
      const payload = {
        email: email,
        event_details: logText,
        event_name: "comment",
      };
      const res = await workOrder.addLogAttachment(
        work_order_id,
        payload,
        attachment
      );
      setLogText("");
      getLogs();
      setAttachment(null);
    }
  };

  const handleCommentChange = (e) => {
    setCommentText(e.target.value);
  };
  const handleLogsTextChange = (e) => {
    setLogText(e.target.value);
  };

  const handleSelectUser = (email) => {
    if (selectedUser.includes(email)) {
      setSelectedUser((su) => su.filter((s) => s != email));
    } else {
      setSelectedUser((su) => [...su, email]);
    }
  };

  const isSelected = (email) => {
    return selectedUser.includes(email);
  };

  const openMention = Boolean(mentionElement);

  function CustomCell(val) {
    return (
      <td
        style={{
          padding: 0,
          borderBottom: "none",
          display: {
            md: "table-cell",
            sm: "block",
            xs: "block",
          },
          whiteSpace: "nowrap",
          paddingRight: "10px",
          verticalAlign: "top",
        }}
      >
        {val}
      </td>
    );
  }
  function CustomCellValue(val) {
    return (
      <td
        style={{
          padding: 0,
          borderBottom: "none",
          display: {
            md: "table-cell",
            sm: "block",
            xs: "block",
          },
        }}
      >
        {val}
      </td>
    );
  }

  return (
    <div
      style={{
        mt: 2,
        zIndex: 9,
        position: "relative",
        p: {
          sm: 3,
          xs: 1,
        },
      }}
    >
      <div className="d-flex align-items-center">
        <div className="bg-opacity-10 bg-white btn-attachment">
          <input
            type="file"
            onChange={handleAttachment}
            style={{ display: "none" }}
            id="input-file"
          />
          <label htmlFor="input-file" style={{ cursor: "pointer" }}>
            <i className="fa fa-paperclip fa-lg"></i>
          </label>
        </div>

        <div className="flex-fill ps-2">
          <div className="position-relative d-flex align-items-center">
            <div className="flex-1 border border-theme mentions">
              <MentionsInput
                placeholder="Add a comment"
                value={logText}
                onChange={handleLogsTextChange}
                className="mentions"
                classNames={classNames}
                a11ySuggestionsListLabel={"Suggested mentions"}
              >
                <Mention
                  trigger="@"
                  data={users}
                  className={classNames.mentions__mention}
                />
              </MentionsInput>
              {attachment ? (
                <div style={{ display: "flex" }}>
                  <div className={style.attachment}>
                    <div style={{ paddingTop: "3px" }}>
                      <i className="fa fa-paperclip"></i>
                    </div>
                    <div style={{ paddingTop: "3px" }}>{attachmentName}</div>
                  </div>
                </div>
              ) : null}
            </div>

            <div
              onClick={handleSubmitLogAttachment}
              className="position-absolute end-0 text-center"
            >
              <a href="#/" className="text-inverse text-opacity-50 me-2">
                <i className="fa fa-paper-plane fa-lg"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
      {logs.map((log, index) => {
        return (
          <div
            key={log.alert_logs_id}
            className={"mt-3 mb-5"}
            style={{ fontSize: 13 }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                position: "relative",
                alignItems: "stretch",
              }}
            >
              <div>
                <div className={style.usernameWrapper}>
                  {getNick(`${log.user?.firstname} ${log.user?.lastname}`)}
                </div>
              </div>
              <div
                style={{
                  marginLeft: "10px",
                  flex: 1,
                  borderRadius: "10px",
                  overflowWrap: "anywhere",
                  "&.MuiGrid-item": { paddingTop: "15px" },
                }}
              >
                <div
                  className={"position-absolute"}
                  style={{
                    position: {
                      md: "absolute",
                      xs: "relative",
                      sm: "relative",
                    },
                    marginLeft: "10px",
                    right: "10px",
                    fontSize: {
                      md: "13px",
                      sm: "11px",
                      xs: "11px",
                    },
                    "&.MuiGrid-item": { paddingTop: "15px" },
                  }}
                >
                  {formatDateTime(log.created_at)}
                </div>
                <div
                  className={"mb-1"}
                  style={{
                    display: {
                      md: log.event === "comment" ? "block" : "flex",
                      sm: "block",
                      xs: "block",
                    },
                  }}
                >
                  <div
                    style={{
                      whiteSpace: "nowrap",
                      fontWeight: "bold",
                      fontSize: "13px",
                      marginRight: "5px",
                    }}
                  >{`${log.user?.firstname} ${log.user?.lastname}`}</div>
                  <div
                    style={{
                      display: {
                        md: "flex",
                        xl: "flex",
                        sm: "block",
                        xs: "block",
                      },
                    }}
                  >
                    {log.event === "comment" && (
                      <MentionsInput
                        placeholder="Add a comment"
                        value={log.detail}
                        readOnly={true}
                        className="mentions small inline"
                        classNames={classNames}
                        a11ySuggestionsListLabel={"Suggested mentions"}
                      >
                        <Mention
                          trigger="@"
                          data={users}
                          className={classNames.mentions__mention}
                        />
                      </MentionsInput>
                    )}

                    {log.event === "status_updated" && (
                      <div>
                        has updated the Work Order to "<b>{log.detail}</b>"
                      </div>
                    )}

                    {log.event === "wo_updated" &&
                      JSON.parse(log.detail).map((d, i) => (
                        <div key={i}>
                          has changed the <b>{d.key}</b> to "{d.value}"
                        </div>
                      ))}
                  </div>
                  {/*{log.action && log.action?.action_name !== "Re-open" ? (*/}
                  {/*  <div*/}
                  {/*    onClick={() => {*/}
                  {/*      showAction(log.event_action, log.action);*/}
                  {/*    }}*/}
                  {/*    style={{*/}
                  {/*      textDecoration: "underline",*/}
                  {/*      cursor: "pointer",*/}
                  {/*    }}*/}
                  {/*  >*/}
                  {/*    [ Details ]*/}
                  {/*  </div>*/}
                  {/*) : null}*/}
                </div>

                {log.attachments?.photo && log.event === "comment" ? (
                  <div>
                    <Attachment docs={log.attachments?.photo} />
                  </div>
                ) : null}
                {/*{`${log.event_details}`}{" "}*/}
              </div>
            </div>
            {log.work_order_comments?.length === 0 ? (
              <div>
                <div
                  onClick={() => handleClickAddComment(index)}
                  style={{
                    textDecoration: "underline",
                    marginLeft: "40px",
                    marginTop: "5px",
                    cursor: "pointer",
                    display: "flex",
                  }}
                >
                  <div>Add Comment</div>
                </div>

                <div
                  style={{
                    paddingLeft: "40px",
                    display: showAddComment === index ? "block" : "none",
                  }}
                >
                  <div className={"d-flex border border-theme mt-2"}>
                    <div className={"flex-1 mentions"}>
                      <MentionsInput
                        placeholder="Add comment"
                        value={commentText}
                        onChange={handleCommentChange}
                        className="mentions"
                        classNames={classNames}
                        a11ySuggestionsListLabel={"Suggested mentions"}
                      >
                        <Mention
                          trigger="@"
                          data={users}
                          className={classNames.mentions__mention}
                        />
                      </MentionsInput>
                      {attachmentComment ? (
                        <div style={{ display: "flex" }}>
                          <div className={style.attachment}>
                            <div style={{ paddingTop: "3px" }}>
                              <i className="fa fa-paperclip"></i>
                            </div>
                            <div style={{ paddingTop: "3px" }}>
                              {attachmentCommentName}
                            </div>
                          </div>
                        </div>
                      ) : null}
                    </div>
                    <div style={{ cursor: "pointer" }}>
                      <input
                        type="file"
                        onChange={handleAttachmentComment}
                        style={{ display: "none" }}
                        id="input-file-comment"
                      />
                      <label
                        htmlFor="input-file-comment"
                        style={{
                          cursor: "pointer",
                          padding: "7px",
                          width: "36px",
                        }}
                      >
                        <i
                          className="fa fa-paperclip"
                          style={{ fontSize: "20px" }}
                        ></i>
                      </label>
                    </div>
                    <div
                      style={{
                        padding: "7px",
                        width: "36px",
                      }}
                    >
                      <i
                        className="fa fa-paper-plane"
                        onClick={() => handleSubmitComment(log.id)}
                        style={{
                          fill: "#1DCBFF",
                          cursor: "pointer",
                          fontSize: "20px",
                        }}
                      ></i>
                    </div>
                  </div>
                </div>
              </div>
            ) : null}

            {log.work_order_comments?.length
              ? log.work_order_comments
                  .sort((a, b) => {
                    let da = new Date(a.created_at),
                      db = new Date(b.created_at);
                    return da - db;
                  })
                  .map((c, indexComment) => {
                    return (
                      <div
                        key={c.created_at}
                        spacing={1}
                        className={"mt-2"}
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          position: "relative",
                          alignItems: "stretch",
                          paddingLeft: "50px",
                        }}
                      >
                        <div>
                          <div className={style.usernameWrapper}>
                            {getNick(
                              `${c.commenter_user?.firstname} ${c.commenter_user?.lastname}`
                            )}
                          </div>
                        </div>
                        <div style={{ flex: 1 }}>
                          <div
                            style={{
                              marginLeft: "10px",
                              position: "relative",
                              p: 1,
                              borderRadius: 1,
                            }}
                          >
                            <div container spacing={1}>
                              <div
                                item
                                style={{
                                  position: "absolute",
                                  right: "10px",
                                  fontSize: "13px",
                                  "&.MuiGrid-item": { paddingTop: "15px" },
                                }}
                              >
                                {formatDateTime(c.created_at)}
                              </div>

                              <div>
                                <div
                                  style={{
                                    fontWeight: "bold",
                                    overflowWrap: "anywhere",
                                    whiteSpace: "nowrap",
                                  }}
                                >
                                  {`${c.commenter_user?.firstname} ${c.commenter_user?.lastname}`}
                                </div>

                                <div>
                                  <MentionsInput
                                    placeholder="Add a comment"
                                    value={c.comment}
                                    readOnly={true}
                                    className="mentions small"
                                    classNames={classNames}
                                    a11ySuggestionsListLabel={
                                      "Suggested mentions"
                                    }
                                  >
                                    <Mention
                                      trigger="@"
                                      data={users}
                                      className={classNames.mentions__mention}
                                    />
                                  </MentionsInput>
                                  {c.attachments?.photo ? (
                                    <Attachment docs={c.attachments?.photo} />
                                  ) : null}
                                </div>
                              </div>

                              {c.commenter == username ? (
                                <div
                                  style={{
                                    position: "absolute",
                                    right: "5px",
                                    top: "10px",
                                  }}
                                >
                                  {/* <span>
                                    <img
                                      src="/icons/edit.png"
                                      style={{
                                        cursor: "pointer",
                                        width: "22px",
                                        marginRight: "5px",
                                        padding: "5px 4px",
                                      }}
                                      onClick={() => {}}
                                    />
                                  </span> */}

                                  <span>
                                    <img
                                      src="/icons/bin.png"
                                      style={{
                                        cursor: "pointer",
                                        width: "22px",
                                        marginRight: "5px",
                                        marginTop: "5px",
                                        padding: "5px 4px",
                                      }}
                                      onClick={() => {
                                        handleDelete(c);
                                      }}
                                    />
                                  </span>
                                </div>
                              ) : null}
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })
              : null}

            {log.work_order_comments?.length ? (
              <>
                <div
                  className={"mt-1"}
                  style={{
                    textDecoration: "underline",
                    marginLeft: "80px",
                    mt: 1,
                    cursor: "pointer",
                  }}
                  onClick={() => handleClickAddComment(index)}
                >
                  <i className="fa fa-reply"></i> Reply
                </div>

                <div
                  style={{
                    marginLeft: "70px",
                    display: showAddComment === index ? "block" : "none",
                  }}
                >
                  <div className={"d-flex border border-theme mt-2"}>
                    <div className={"flex-1 mentions"}>
                      <MentionsInput
                        placeholder="Add Reply"
                        value={commentText}
                        onChange={handleCommentChange}
                        className="mentions"
                        classNames={classNames}
                        a11ySuggestionsListLabel={"Suggested mentions"}
                      >
                        <Mention
                          trigger="@"
                          data={users}
                          className={classNames.mentions__mention}
                        />
                      </MentionsInput>
                      {attachmentComment ? (
                        <div style={{ display: "flex" }}>
                          <div className={style.attachment}>
                            <div style={{ paddingTop: "3px" }}>
                              <i className="fa fa-paperclip"></i>
                            </div>
                            <div style={{ paddingTop: "3px" }}>
                              {attachmentCommentName}
                            </div>
                          </div>
                        </div>
                      ) : null}
                    </div>
                    <div style={{ cursor: "pointer" }}>
                      <input
                        type="file"
                        onChange={handleAttachmentComment}
                        style={{ display: "none" }}
                        id="input-file-reply"
                      />
                      <label
                        htmlFor="input-file-reply"
                        style={{
                          cursor: "pointer",
                          padding: "7px",
                          width: "36px",
                        }}
                      >
                        <i
                          className="fa fa-paperclip"
                          style={{ fontSize: "20px" }}
                        ></i>
                      </label>
                    </div>
                    <div
                      style={{
                        padding: "7px",
                        width: "36px",
                      }}
                    >
                      <i
                        className="fa fa-paper-plane"
                        onClick={() => handleSubmitComment(log.id)}
                        style={{
                          fill: "#1DCBFF",
                          cursor: "pointer",
                          fontSize: "20px",
                        }}
                      ></i>
                    </div>
                  </div>
                </div>
              </>
            ) : null}
          </div>
        );
      })}
    </div>
  );
};
